import axios from "@/plugins/axios";

let url = "/api/console/roulette/configs";

export const configs = {
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
    get(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
    post(data){
        console.log(data);
        return axios.post(url, data).then(result => result.data);
    },
    put(data){
        return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    },
    delete(data){
        return axios.delete(`${url}/${data._id}`).then(result => result.data);
    },

    test() {
        return axios.get(`${url}/test`).then(result => result.data);
    },
    
    reset() {
        return axios.get(`${url}/reset`).then(result => result.data);
    },

    image: {
        post(_config, thumb){
            let formData = new FormData();
            formData.append("image", thumb);
            return axios.post(`${url}/${_config}/image`, formData, { headers: { "Content-Type": "multipart/form-data" } }).then(result => result.data);
        },
        post2(_config, thumb){
            let formData = new FormData();
            formData.append("image2", thumb);
            return axios.post(`${url}/${_config}/image2`, formData, { headers: { "Content-Type": "multipart/form-data" } }).then(result => result.data);
        }
    },
}